<script setup lang="ts">
import FileInput from '@/components/forms/FileInput/FileInput.vue';
import { VeeFileInputProps } from '@/components/forms/types.ts';
import { useField } from 'vee-validate';
import { computed, toRef, useAttrs } from 'vue';
import { useVeeFormProps } from '../utils';

const props = defineProps<VeeFileInputProps>();
const files = defineModel('files', { type: Array<File>, default: [] });
defineOptions({
  inheritAttrs: true,
});
const slots = defineSlots<{ [key: string]: unknown }>();

const veeProps = useVeeFormProps(props);

const attrs = useAttrs();
const passdownAttrs = computed(() => ({
  ...attrs,
  class: undefined,
}));

const { errorMessage, value, handleChange, handleBlur, meta } = useField<File[]>(
  toRef(() => props.name),
  undefined,
  {
    validateOnValueUpdate: false,
  },
);

function onUpdate(input: File[]) {
  handleChange(input, meta.touched);
  files.value = input;
}

function onBlur(event: FocusEvent) {
  handleBlur(event, true);
}
</script>

<template>
  <FileInput
    v-bind="{ ...veeProps, ...passdownAttrs }"
    :modelValue="value"
    :errorMessage="errorMessage"
    @update:modelValue="onUpdate"
    @blur="onBlur"
  >
    <template v-for="(_, name) in slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </FileInput>
</template>
